import { render } from "./footerES.vue?vue&type=template&id=16f3ee6a&scoped=true"
import script from "./footerES.vue?vue&type=script&lang=js"
export * from "./footerES.vue?vue&type=script&lang=js"

import "./footerES.vue?vue&type=style&index=0&id=16f3ee6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f3ee6a"]])

export default __exports__